import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { SnippetPageSection } from '@/shared/api-generated-types'
import Snippet from '@/widgets/Snippet'
import React from 'react'

export interface Props extends Partial<SnippetPageSection> {}

const SnippetBlock = ({ items, title }: Props): JSX.Element | null => {
  if (!items?.length) return null

  return (
    <div className="pb-md">
      <Text tag="h2" size="md" responsiveSize={{ sm: 'md', lg: 'lg' }} weight="md" className="pb-sm">
        {title}
      </Text>
      <Layout spacing="md">
        <Stack y>
          {items.map((item, index) => (
            <Snippet key={index} {...item} />
          ))}
        </Stack>
      </Layout>
    </div>
  )
}
export default React.memo(SnippetBlock)
